import React, { useContext } from 'react'
import Placeholder from '../../../Atoms/Placeholder'
import { CardContext } from '..'

import styles from './index.module.css'

export interface ITagProps {
  children: React.ReactNode
}

function Tag(props: ITagProps) {
  const { children } = props
  const { size, variant } = useContext(CardContext)

  if (variant === 'lite' || variant === 'fixed-height') {
    return null
  }

  const showRenderOverHeader = size === 'm' || size === 'l'

  return (
    <div className={styles.tag} data-overheader={showRenderOverHeader}>
      {children}
    </div>
  )
}

Tag.displayName = 'Card.Tag'

function TagPlaceholder() {
  return <Placeholder height="24px" width="50%" rounded />
}

TagPlaceholder.displayName = 'Card.Tag.Placeholder'
Tag.Placeholder = TagPlaceholder

export { Tag }
